import React from "react";
import Card from "components/card";

const SummaryCard = ({
    dispalyCount,
    description,
    Icon,
    variant = "purple"
}) => {
    return (
        <Card className={`summary-wall ${variant}`}>
            <div className="pb-6 p-4">
                <div className="flex items-center gap-3">

                    <div className="p-2 rounded-full icon-bg">
                        {Icon && <Icon className="w-5 h-5 text-color" />}
                    </div>

                    <div>
                        <div className="text-color text-2xl font-bold">
                            {dispalyCount}
                        </div>
                        <div className="text-xs text-slate-700">
                            {description}
                        </div>
                    </div>

                </div>
            </div>
        </Card>
    );
};

export default SummaryCard;